import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Observable, lastValueFrom } from 'rxjs';
import { ICompany, ICompanyPage } from '../models/company.model';
import { IViaCepAnswer } from '../models/viacep-answer.model';
import { GlobalConfigService } from './global-config.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
       private get baseUrl(): string {
           return this.globalConfig.getApiUrl() + '/companies';
         }
       
         constructor(
           private http: HttpClient,
           private globalConfig: GlobalConfigService
         ) { }

  listCompanies(pageNumber: number, pageSize: number, orderBy: string, sortBy: string, search: string = ''): Observable<ICompanyPage> {
    const params: any = {
      pageNumber,
      pageSize,
      orderBy,
      sortBy
    };

    
    if (search && search.trim() !== '') {
      params.search = search;
    }
    
    return this.http.get<any>(`${this.baseUrl}`, {
      params
    });
  }

  /**
   * Recupera empresa por ID.
   * @param companyId CNPJ/ID da empresa
   * @param lite Quando true retorna payload reduzido. ROOT envia false para completo.
   */
  getCompanyById(companyId: string, lite: boolean = false): Promise<ICompany> {
    const query = `?lite=${lite}&remove_anamnese_docs=true`;
    return new Promise((resolve, reject) => {
      this.http.get<ICompany>(`${this.baseUrl}/${companyId}${query}`)
        .subscribe({
          next: resolve,
          error: (err) => reject(err?.error)
        });
    });
  }

  createCompany(company: ICompany): Observable<ICompany> {
    return this.http.post<ICompany>(`${this.baseUrl}`, company);
  }

  updateCompany( id: string, company: ICompany): Observable<ICompany> {
    return this.http.put<ICompany>(`${this.baseUrl}/${id}`, company);
  }

  deleteCompany(companyId: string): Observable<any> {
    return this.http.delete<any>(`${this.baseUrl}/${companyId}`);
  }

  getCepInfo(cep: string): Promise<IViaCepAnswer> {
    return new Promise((resolve, reject) => {
      this.http.get<IViaCepAnswer>(`${this.baseUrl}/cep/${cep}`)
        .subscribe({
          next: (response) => {
            resolve(response);
          },
          error: (err) => {
            reject(err?.error);
          }
        });
    });
  }

  generateLogoUploadUrl(cnpj: string, fileName: string, contentType: string): Promise<{ uploadUrl: string; objectKey: string; fileName: string }> {
    return lastValueFrom(
      this.http.post<{ uploadUrl: string; objectKey: string; fileName: string }>(
        `${this.baseUrl}/${cnpj}/logo/generate-upload-url`,
        { file_name: fileName, content_type: contentType }
      )
    );
  }

  uploadFileToS3(uploadUrl: string, file: File): Promise<void> {
    return lastValueFrom(
      this.http.put<void>(uploadUrl, file)
    );
  }

  setClinicAutentiqueToken(cnpj: string, autentiqueApiToken: string): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${cnpj}/autentique-token`, { autentique_api_token: autentiqueApiToken });
  }

}